/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanButton from 'vant/es/button'
import 'vant/es/button/style/less'
import '/Users/noromacpro/work/orale-h5/vant-extra/style-override/button.css'
import VanCalendar from 'vant/es/calendar'
import 'vant/es/calendar/style/less'
import VanField from 'vant/es/field'
import 'vant/es/field/style/less'
import VanForm from 'vant/es/form'
import 'vant/es/form/style/less'


import { render, staticRenderFns } from "./information.vue.js?vue&type=template&id=5130659c&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=template&id=5130659c&scoped=true"
import script from "./information.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=script&setup=true&lang=js"
import style0 from "./information.vue.css?vue&type=style&index=0&id=5130659c&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=style&index=0&id=5130659c&prod&lang=css"
import style1 from "./information.vue.postcss?vue&type=style&index=1&id=5130659c&prod&lang=postcss&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=style&index=1&id=5130659c&prod&lang=postcss&scoped=true"
import style2 from "./information.vue.css?vue&type=style&index=2&id=5130659c&prod&lang=css!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./information.vue?vue&type=style&index=2&id=5130659c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130659c",
  null
  
)

export default component.exports
installComponents(component, {VanButton,VanCalendar,VanField,VanForm})
